import Axios from 'axios';
import loadable from '@loadable/component';
import uniqueSelector from 'unique-selector';
import { getCartLink, getLangPath } from 'components/cart/Utils';

var jQuery = require('jquery/src/core');
require('jquery/src/core/init');
require('jquery/src/selector');
require('jquery/src/event');
require('jquery/src/traversing');
require('jquery/src/event/trigger');
require('jquery/src/manipulation');
require('jquery/src/attributes');
// require('jquery/src/deprecated');

window.onSubmit = undefined;
window.upsellCartStopped = false;
var DelayedEvents = [];
var additionalCartLinks = [
    "a[data-toggle='mini-cart-desktop-info']",
    "a[data-toggle='mini-cart-info']",
    '.minicart-link',
    '.cart-link__bubble',
    '.js-drawer-open-cart',
    '.cd-cart-trigger',
    '.tt-desctop-parent-cart.tt-parent-box',
    '.basket.cart-toggle',
    '.tt-cart .tt-dropdown-toggle',
    "a[data-node-type='commerce-cart-open-link']"
];
var elementPickerEnabled = false;

// if (process.env.BETA === "true") {
//   console.log(
//     "%c%s",
//     "background: #00ffc4; color: #021c16; font-size: 12px; font-weight:bold; padding: 5px 10px; border-radius: 3px",
//     "MONSTER BETA"
//   );
// }

export var manualSetupCartLinks = [
    "a[data-href='/cart']",
    `a[data-href='https://${window.mu_origin}/cart']`
]
    .concat(additionalCartLinks)
    .join();

export var cartLinks = [
    "a[href='/cart']",
    "a[href$='/cart']",
    `a[href='https://${window.mu_origin}/cart']`,
    'div.minicart__button.monster'
]
    .concat(manualSetupCartLinks)
    .concat((window.mu_custom_links || []).map(({ selector }) => selector))
    .join();

function immediatePropStopped(event, label) {
    var msg = '';
    if (event.isImmediatePropagationStopped()) {
        msg = label + ' stopImmediatePropagation called';
    } else {
        msg = label + ' stopImmediatePropagation not called';
    }
}

export const getParams = (url) => {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};

const handleResize = () => {
    document.documentElement.style.setProperty('--screen-height', `${window.innerHeight}px`);
    // document.documentElement.style.setProperty('--screen-width', `${window.innerWidth}px`);
};

export function stopUpsellCart() {
    window.upsellCartStopped = true;
}

export const controlTheme = () => {
    console.log(
        '%c%s',
        'background: #1c64f6; color: #fff; font-size: 12px; font-weight:bold; padding: 5px 10px; border-radius: 3px',
        '⚡️ MONSTER UPSELLS cart is controlling the theme ⚡️'
    );
    if (!window.mu_stop_resize) {
        jQuery(window).on('resize', handleResize);
        jQuery(window).on('scroll', handleResize);
    }
    jQuery('head meta[name="viewport"]').attr(
        'content',
        `width=device-width, initial-scale=1.0${
            window.mu_allow_zoom ? '' : ', maximum-scale=1.0,user-scalable=0'
        }`
    );

    window.handleAddToCart = (event) => {
        if (window.upsellCartStopped) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        if (window.onSubmit) return window.onSubmit(event);
        else if (window.monster_submitAddToCartForm && window.monster_setCartItems)
            monster_submit(event);
        else {
            DelayedEvents.push({
                type: 'submit',
                target: event.target
            });
        }
    };

    // jQuery("form[data-zp-add-to-cart-form]").each(function () {
    //   jQuery(this)
    //     .removeAttr("data-zp-add-to-cart-form")
    //     .attr("action", "/cart/add");
    // });
    jQuery(document).on('submit', `form[action*='/cart/add']`, (e) => {
        return window.handleAddToCart(e);
    });
    window.removeSelectors_keepStyle = (element) => {
        const style = window.getComputedStyle(element);
        [...element.children].forEach((child) => window.removeSelectors_keepStyle(child));
        element.style = style;
        element.className = '';
        element.setAttribute('id', '');
    };

    let ATC_SELECTOR =
        "form[action*='/cart/add'] button[name='add'], form[action*='/cart/add'] button[data-checkout='same'], form[action*='/cart/add'] button[type='submit'],form[action*='/cart/add'] input[type='submit'], form[action*='/cart/add'] button[data-add-to-cart],form[action*='/cart/add'] label[role='submit'],form[data-zp-product-url='/cart'] button[type='submit'], form[action*='/cart/add'] a[role='submit'], [data-zp-add-to-cart]";
    jQuery(window.mu_atc_selector ?? ATC_SELECTOR).on('click', function (event) {
        if (window.upsellCartStopped) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        const atcButton = jQuery(this);
        const form = atcButton.closest("form[action*='/cart/add'], [data-zp-add-to-cart-form]");
        if (form.length) {
            atcButton.attr('type', 'submit');
            atcButton.removeAttr('data-product-id');
            return window.handleAddToCart({
                preventDefault: () => null,
                stopImmediatePropagation: () => null,
                target: form.get(0)
            });
        }
    });

    jQuery('[data-pf-type="ProductATC"]:not(.disable-monster)').on('click', async function (event) {
        const atcButton = jQuery(this);
        if (window.upsellCartStopped) {
            return;
        }
        event.stopImmediatePropagation();
        event.preventDefault();
        const form = atcButton.closest("form[action*='/cart/add']");
        if (form.length) {
            return window.handleAddToCart({
                preventDefault: () => null,
                stopImmediatePropagation: () => null,
                target: form.get(0)
            });
        }
        if (window.mu_custom_atc_logic) {
            const continueATC = await window.mu_custom_atc_logic(event);
            if (continueATC === false) return;
        }
        const variantDiv = atcButton.siblings(
            '[data-pf-type="ProductVariant"], [data-pf-type="ProductVariantSwatches"]'
        );
        const combined = variantDiv.attr('data-combined');
        let quantity =
            atcButton
                .prev('[data-pf-type="ProductQuantity"]')
                .find("[data-pf-type='QuantityField']")
                .val() || 1;
        quantity = Number(quantity);
        if (combined) {
            const variant_id = variantDiv.find('[name="id"]').val();
            window.onSubmit(null, { id: variant_id, quantity });
        } else {
            const product_id = atcButton.attr('data-product-id');
            const selected_options = getPageFlyOptions(variantDiv);
            const product_data = window.__pageflyProducts && window.__pageflyProducts[product_id];
            if (product_data && selected_options.length) {
                const selected_variant = getPageFlyVariant(selected_options, product_data);
                if (selected_variant) {
                    window.onSubmit(null, { id: selected_variant.id, quantity });
                }
            } else if (product_data) {
                window.onSubmit(null, { id: product_data.variants[0].id, quantity });
            }
        }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        const cartWrapper = document.getElementById("monster-cart-wrapper");
        if (cartWrapper && window.closeCart) {
          window.closeCart();
          const lastAtcButton =
            document.querySelector(ATC_SELECTOR) ||
            document.querySelector(
              '[data-pf-type="ProductATC"], [data-pf-type="ProductATC2"]'
            );
          if (lastAtcButton) lastAtcButton.focus();
        }
      }
    });

    function getPageFlyOptions(variantDiv) {
        const selected_options = [];
        const isRadio = variantDiv.attr('data-display') === 'radio';
        if (isRadio) {
            variantDiv.find("input[type='radio']:checked").each(function () {
                const value = jQuery(this).val();
                if (value) selected_options.push(value);
            });
        } else {
            variantDiv.find('select.pf-variant-select').each(function () {
                const value = jQuery(this).val();
                if (value) selected_options.push(value);
            });
        }
        return selected_options;
    }

    function getPageFlyVariant(selected_options, product_data) {
        const selected_title = selected_options.join(' / ');
        const selected_variant = product_data.variants.find(
            ({ title }) => title === selected_title
        );
        return selected_variant;
    }
    function toggleCart(event) {
        if (window.upsellCartStopped || window?.MANUAL_SETUP_ACTION === 'cart_link') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (window.toggleCart) return window.toggleCart();
        else {
            DelayedEvents.push({
                type: 'click',
                target: event.target
            });
        }
    }
    jQuery(cartLinks).on('click', toggleCart);
    jQuery(document).on('click', cartLinks, toggleCart);

    function IDGetter(settings, element) {
        const { type, selector, name } = settings;
        if (type === 'self-attr') {
            return element.attr(name);
        }
        const idElement = jQuery(selector);
        const parsedId = type === 'attr' ? idElement.attr(name) : idElement.val();
        return parsedId;
    }
    function cloneCustomATC(settings) {
        const elements = jQuery(settings.button);
        if (!elements.length) return;
        elements.each(function () {
            const element = jQuery(this);
            const clone = element[0].cloneNode(true);
            jQuery(clone).unbind().attr('clone', true);
            clone.addEventListener('click', (event) => {
                if (!window.onSubmit) return;
                event.preventDefault();
                event.stopImmediatePropagation();
                if (settings.id.type === 'hasFormParent') {
                    const form = jQuery(clone).closest("form[action='/cart/add']");
                    if (form.length) {
                        return window.handleAddToCart({
                            preventDefault: () => null,
                            stopImmediatePropagation: () => null,
                            target: form[0]
                        });
                    }
                }
                const id = IDGetter(settings.id, element);
                if (id) {
                    window.onSubmit(null, { id, quantity: 1 });
                }
            });
            element.replaceWith(clone);
        });
    }
    if (window.mu_custom_atcs?.length) {
        window.mu_custom_atcs.forEach(cloneCustomATC);
    }
};

// function activateWideBundleIntegration() {
//   // WIDE BUNDLE APP SUPPORT
//   const atc_btn = jQuery("#new-form-atc");
//   if (atc_btn.length) {
//     const old_onclick = atc_btn[0].onclick;
//     const wb_atc_clone = atc_btn.clone().addClass("clone");
//     atc_btn.replaceWith(wb_atc_clone);
//     wb_atc_clone.on("click", function (event) {
//       if (window.upsellCartStopped) {
//         return old_onclick();
//       }
//       addLoadingATC();
//       event.stopImmediatePropagation();
//       event.preventDefault();
//       const id = getSelectedID();
//       if (id) {
//         window.onSubmit(null, { id, quantity: 1 });
//       }
//       putBackATC();
//       putBackATC(); // for some reason we need to call this twice
//     });
//   }
//   // END OF WIDE BUNDLE APP SUPPORT
// }

export function init({ handleSubmit }) {
    // activateWideBundleIntegration()
    window.onSubmit = handleSubmit;
    window.monster_atc = ({ id, quantity = 1 }) => handleSubmit(null, { id, quantity });
    DelayedEvents.forEach(({ type, target }) => {
        jQuery(target).trigger(type);
    });
}

const fetchProductDetails = async (handle) => {
    try {
        const response = await Axios.get(getLangPath(`/products/${handle}.json`));
        const productData = response.data.product;
        return productData;
    } catch (error) {
        console.error(`Error fetching product details for product ID ${handle}:`, error);
        return null;
    }
};

export const getCartItems = async () => {
    const origin = window.location.origin;
    return new Promise((resolve, reject) => {
        Axios.get(getCartLink())
            .then(async ({ data: { token, items, cart_level_discount_applications } }) => {
                const cartItemsWithComparedPrices = window.mu_cart_with_compares
                    ? await Promise.all(
                          items.map(async (cartItem) => {
                              const productDetails = await fetchProductDetails(cartItem.handle);
                              const variant_data = productDetails?.variants.find(
                                  (variant) => variant.id === cartItem.variant_id
                              );

                              if (variant_data) {
                                  cartItem.compare_at_price =
                                      Number(variant_data.compare_at_price) * 100;
                              }

                              return cartItem;
                          })
                      )
                    : items;
                if (cartItemsWithComparedPrices.length === 0) {
                    thankYouPageCleanup();
                }
                resolve({
                    token,
                    items: cartItemsWithComparedPrices,
                    cart_level_discount_applications
                });
            })
            .catch(reject);
    });
};
window.monster_getCartItems = getCartItems;
function thankYouPageCleanup() {
    localStorage.removeItem('monster_uc_upsells');
    localStorage.removeItem('mu_form_files');
    localStorage.removeItem('cart_items');
    // function removeByCondition(condition) {
    //     Object.entries(localStorage)
    //         .map((x) => x[0])
    //         .filter(condition)
    //         .map((x) => localStorage.removeItem(x));
    // }
    // removeByCondition((x) => x?.contains('one_tick_removed_'));
    // removeByCondition((x) => x?.contains('multi_gifts_'));
}
async function refreshCart(open = true, callback = () => {}) {
    await fetch(window.location.origin + '/cart.js')
        .then((res) => res.json())
        .then(async (response) => {
            if (window.monster_setCartItems && window.mu_productionAddToCartCallBack) {
                await window.monster_setCartItems(
                    response.items,
                    response.cart_level_discount_applications
                );
                await window.mu_productionAddToCartCallBack(response.items);
            }
            if (open && window.openCart) await window.openCart();
            callback();
        })
        .catch((error) => {
            console.log(error);
        });
}

window.monster_refresh = refreshCart;

async function monster_addToCart({ id, quantity, ...rest }, open = true, callback = () => {}) {
    await fetch(window.location.origin + '/cart/add.js', {
        headers: {
            'content-type': 'application/json;'
        },
        body: JSON.stringify({
            id: Number(id),
            quantity: Number(quantity),
            ...rest
        }),
        method: 'POST'
    })
        .then(async () => {
            await refreshCart(open);
            callback();
        })
        .catch((error) => {
            console.log(error);
        });
}

window.monster_addToCart = monster_addToCart;

function serializeForm(form) {
    const formData = new FormData(form);
    let serialized = { properties: {} };

    for (const [name, value] of formData) {
        if (name.includes('properties')) {
            const start = name.indexOf('[') + 1;
            const end = name.indexOf(']');
            const key = name.substring(start, end);
            serialized['properties'][key] = value;
        } else if (!name.includes('utf') && !name.includes('form_type')) serialized[name] = value;
    }
    return serialized;
}

async function monster_submit(event) {
    if (event.target && event.target.tagName === 'FORM') {
        const form = event.target;

        if (form.action.includes('/cart/add')) {
            event.preventDefault();

            if (window.mu_custom_atc_logic) {
                const continueATC = await window.mu_custom_atc_logic(event);
                if (continueATC === false) return;
            }

            const id =
                form.querySelector('[name="id"]')?.value ?? window.mu_product?.variants[0].id;
            const quantity = form.querySelector('[name="quantity"]')?.value ?? 1;
            console.log('monster_addToCart');
            await monster_addToCart({ id, quantity, ...serializeForm(form) });
        } else {
            console.log('Monster : Unsuposted add to cart form');
        }
    } else {
        DelayedEvents.push({
            type: 'submit',
            target: event.target
        });
    }
}

window.monster_submitAddToCartForm = monster_submit;

export const getCartNote = async () => {
    return new Promise((resolve, reject) => {
        Axios.get(getCartLink())
            .then(({ data: { note } }) => resolve(note))
            .catch(reject);
    });
};

export const clearCart = async () => {
    return new Promise((resolve, reject) => {
        Axios.post(`${window.location.origin}/cart/clear.js`)
            .then(({ data }) => resolve(data))
            .catch(reject);
    });
};

window.monster_clearCart = clearCart;
